module.exports = __webpack_public_path__ + "img/7.4d32e8c2.jpg";